import { Outlet } from 'react-router-dom';
import { Brand } from '@/components/brand/Brand';

/**
 * Sober DS (v2) auth layout — split screen (brand aside + form). Story 27.29.
 * Left: brand panel with two slow-floating blobs (motion-safe) + pitch + quote.
 * Right: the form card. Collapses to a single column on mobile (brand hidden,
 * the form's own mobile logo shows). No colored borders — color is the brand
 * gradient + blobs only.
 */
export function AuthLayout() {
  return (
    <div data-ui="v2" className="v2-root font-sober grid min-h-dvh-safe lg:grid-cols-[1.05fr_1fr]">
      <aside className="relative hidden overflow-hidden bg-gradient-to-br from-[#fea42d] to-[#f5647a] p-10 text-white lg:flex lg:flex-col lg:justify-between">
        {/* readability veil — keeps the white copy legible over the warm brand gradient */}
        <span
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 bg-[radial-gradient(130%_120%_at_15%_0%,transparent_45%,rgba(28,29,33,0.24))]"
        />
        {/* floating blobs (mkFloatSlow) */}
        <span
          aria-hidden="true"
          className="pointer-events-none absolute -left-16 top-10 size-72 rounded-full bg-white/15 blur-2xl motion-safe:animate-float-slow"
        />
        <span
          aria-hidden="true"
          className="pointer-events-none absolute -right-10 bottom-0 size-80 rounded-full bg-white/10 blur-3xl motion-safe:animate-float-slow"
          style={{ animationDelay: '1.5s' }}
        />

        <Brand className="relative" size="lg" tone="inverse" />

        <div className="relative max-w-md [text-shadow:0_1px_2px_rgba(28,29,33,0.20)]">
          <p className="text-so-12 font-bold uppercase tracking-[0.18em] text-white/90">
            Quem organiza, fatura.
          </p>
          <h2 className="mt-2 text-so-28 font-bold leading-tight">Tudo da sua clínica em um só lugar.</h2>
          <p className="mt-3 text-so-14 text-white/85">
            Agenda, WhatsApp, financeiro e IA — para você cuidar dos pacientes, não da papelada.
          </p>
          <figure className="mt-8 rounded-so-lg bg-white/10 p-5">
            <blockquote className="text-so-14 text-white/95">
              “Reduzi as faltas em 40% com os lembretes automáticos. A equipe inteira vive dentro do ValiosasCRM.”
            </blockquote>
            <figcaption className="mt-3 text-so-12 text-white/80">
              <span className="font-bold text-white">Dra. Marina Alves</span> · Clínica Sttudio Derma · São Paulo
            </figcaption>
          </figure>
        </div>

        <div className="relative text-so-12 text-white/70">© ValiosasCRM</div>
      </aside>

      <main className="flex items-center justify-center p-6 lg:p-8">
        <div className="w-full max-w-[408px]">
          {/* mobile brand logo (brand panel hidden < lg) */}
          <Brand className="mb-6 lg:hidden" />
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default AuthLayout;
